import styled from 'styled-components';
import SmallText from 'components/UI/Typography/SmallText';
import { Spacing, ZIndex } from 'modules/styles/variables';
import { MuiBox, dfdDefaultTheme } from 'theme/material-ui';

export const StyledSmallText = styled(SmallText)`
  margin-left: ${Spacing.medium}px;
  ${dfdDefaultTheme.breakpoints.down('xs')} {
    display: none;
  }
`;

export const CTAMessage = styled(MuiBox)`
  position: absolute;
  z-index: ${ZIndex.spinner};
  left: 0;
  padding: 0 ${Spacing.medium}px;
  height: 100%;
  display: flex;
  align-items: center;
`;
